import { render, staticRenderFns } from "./addAdmin.vue?vue&type=template&id=2407a428&"
import script from "./addAdmin.vue?vue&type=script&lang=js&"
export * from "./addAdmin.vue?vue&type=script&lang=js&"
import style0 from "./addAdmin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports